import { render, staticRenderFns } from "./leadsDashboardReferralList.vue?vue&type=template&id=74af1550&scoped=true"
import script from "./leadsDashboardReferralList.vue?vue&type=script&lang=js"
export * from "./leadsDashboardReferralList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af1550",
  null
  
)

export default component.exports